import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRemappingStore } from "../../../stores/remappingStore";
import { useOfflineSettingsStore } from "../../../stores/offlineSettingsStore";
import RemappingFilters from "./remappingFilters";
import RemappingResultsTable from "./remappingResultsTable";

const RemappingDataBase: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { changes } = useRemappingStore();
  const { offlineSettings, fetchOfflineSettings } = useOfflineSettingsStore();

  const [selection, setSelection] = useState({
    series: "",
    generation: "",
    engine: "",
    ecu: "",
  });

  useEffect(() => {
    fetchOfflineSettings();
  }, []);

  const currentLanguage = i18n.language;
  const offlineSettingsForCurrentLanguage = offlineSettings.find(
    (f) => f.lang === currentLanguage
  );

  return (
    <div className="flex flex-col z-10">
      {/* Header */}
      <div className="max-w-screen-2xl w-full place-self-center text-center pb-10">
        <h1 className="text-4xl font-bold">{t("Remapping Data Base")}</h1>
      </div>

      {/* Filters */}
      <div className="max-w-screen-2xl w-full place-self-center max-md:p-4">
        <RemappingFilters onSelectionChange={setSelection} />
      </div>

      {/* Results */}
      <div className="py-2" />
      <div className="rounded-lg bg-tablebg2 max-w-screen-2xl w-full place-self-center max-md:p-4">
        <RemappingResultsTable
          changes={changes}
          offlineSettingsForCurrentLanguage={offlineSettingsForCurrentLanguage}
        />
      </div>
    </div>
  );
};

export default RemappingDataBase;